import { Link } from 'react-router-dom'

const HEADINGS = {
    'brand-cases': 'Case studies will live here as campaigns wrap.',
    'creator-quotes': 'Creator stories will live here as payouts go out.',
    'general': 'We\'re an early-stage platform building publicly.',
}

function EarlyStageNote({ kind = 'general' }) {
    const heading = HEADINGS[kind] || HEADINGS.general
    const isGeneral = kind === 'general'

    return (
        <div className="early-stage-note">
            <span className="mono-label early-stage-note__eyebrow">building publicly</span>
            <h3 className="early-stage-note__heading">{heading}</h3>
            {isGeneral && (
                <>
                    <p className="early-stage-note__copy">
                        PostPaid is new. Rather than paste fake logos or stock testimonials, we're leaving these slots open until we have real ones to share. Want to be among the first? Pick your path below.
                    </p>
                    <div className="early-stage-note__ctas">
                        <Link to="/brands" className="early-stage-note__cta">
                            Try it as a brand →
                        </Link>
                        <Link to="/creators" className="early-stage-note__cta">
                            Try it as a creator →
                        </Link>
                    </div>
                </>
            )}
        </div>
    )
}

export default EarlyStageNote
